import Vue from 'vue';

const success = function success(response, resolve) {
  resolve(response);
};

const failed = function failed(error, reject) {
  reject(error);
};

export default function status(data) {
  return new Promise((resolve, reject) => {
    Vue.$http
      .post('/unimicro/status', data)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  });
}



// WEBPACK FOOTER //
// ./src/app/services/unimicro/status.js